import { useQuery } from '@gogame/query';

import { loadErrorLog } from 'scenes/MarketingPlanning/MarketingPlanningGrid/sources/marketingPlanning';

import { errorLog } from './queryKeyFactory';

export const useLoadMarketingPlanningErrorLog = ({ year, month }) => {
  return useQuery(errorLog({ year, month }), () =>
    loadErrorLog({ year, month })
  );
};
